export function distance(point1: any, point2: any) {

    let lat1 = point1.lat;
    let lat2 = point2.lat;

    let lon1 = point1.lng;
    let lon2 = point2.lng;

    if ((lat1 == lat2) && (lon1 == lon2)) {
		return 0;
	}
	else {
		var radlat1 = Math.PI * lat1/180;
		var radlat2 = Math.PI * lat2/180;
		var theta = lon1-lon2;
		var radtheta = Math.PI * theta/180;
		var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
		if (dist > 1) {
			dist = 1;
		}
		dist = Math.acos(dist);
		dist = dist * 180/Math.PI;
		dist = dist * 60 * 1.1515;
		dist = dist * 1.609344
		return dist;
	}
}

export function workerIsCompatible(worker: any, announcement: any, company: any) {
    return worker.settori.includes(announcement.settore) &&
		(announcement.patente_agricola ? worker.patente_agricola == announcement.patente_agricola : true) &&
        (announcement.patente ? worker.patente == announcement.patente : true) && //se è richiesta la patente e ce l'ha bene se non è richiesta sticazzi
        (announcement.veicolo ? worker.patente == announcement.veicolo : true) && //se è richiesto un veicolo e ce l'ha bene se non è richiesto sticazzi
        (new Date(announcement.periodo_da) <= new Date(worker.periodo_a)) && (new Date(worker.periodo_da) <= new Date(announcement.periodo_a)) && //l'intersezione degli intervalli di date è non vuota
        company && (distance(worker, company) <= worker.raggio_di_spostamento)
}

export function removeUndefined(obj: any): any {
	Object.keys(obj).forEach(key => obj[key] === undefined ? delete obj[key] : {});
	return obj
}

export const imgmarker = {
        a_: require('@/images/svg/placeholder/Aziende/_.svg'),
        a0: require('@/images/svg/placeholder/Aziende/0.svg'),
        a1: require('@/images/svg/placeholder/Aziende/1.svg'),
        a2: require('@/images/svg/placeholder/Aziende/2.svg'),
        a3: require('@/images/svg/placeholder/Aziende/3.svg'),
        a01: require('@/images/svg/placeholder/Aziende/01.svg'),
        a02: require('@/images/svg/placeholder/Aziende/02.svg'),
        a03: require('@/images/svg/placeholder/Aziende/03.svg'),
        a12: require('@/images/svg/placeholder/Aziende/12.svg'),
        a13: require('@/images/svg/placeholder/Aziende/13.svg'),
        a23: require('@/images/svg/placeholder/Aziende/23.svg'),
        a012: require('@/images/svg/placeholder/Aziende/012.svg'),
        a013: require('@/images/svg/placeholder/Aziende/013.svg'),
        a023: require('@/images/svg/placeholder/Aziende/023.svg'),
        a123: require('@/images/svg/placeholder/Aziende/123.svg'),
        a0123: require('@/images/svg/placeholder/Aziende/0123.svg'),

        r_: require('@/images/svg/placeholder/Risorse/_.svg'),
        r0: require('@/images/svg/placeholder/Risorse/0.svg'),
        r1: require('@/images/svg/placeholder/Risorse/1.svg'),
        r2: require('@/images/svg/placeholder/Risorse/2.svg'),
        r3: require('@/images/svg/placeholder/Risorse/3.svg'),
        r01: require('@/images/svg/placeholder/Risorse/01.svg'),
        r02: require('@/images/svg/placeholder/Risorse/02.svg'),
        r03: require('@/images/svg/placeholder/Risorse/03.svg'),
        r12: require('@/images/svg/placeholder/Risorse/12.svg'),
        r13: require('@/images/svg/placeholder/Risorse/13.svg'),
        r23: require('@/images/svg/placeholder/Risorse/23.svg'),
        r012: require('@/images/svg/placeholder/Risorse/012.svg'),
        r013: require('@/images/svg/placeholder/Risorse/013.svg'),
        r023: require('@/images/svg/placeholder/Risorse/023.svg'),
        r123: require('@/images/svg/placeholder/Risorse/123.svg'),
        r0123: require('@/images/svg/placeholder/Risorse/0123.svg')
    };


export const debounce = <F extends (...args: any[]) => any>(func: F, waitFor: number) => {
  let timeout: number = 0

  return (...args: Parameters<F>): Promise<ReturnType<F>> =>
    new Promise(resolve => {
      if (timeout) {
        clearTimeout(timeout)
      }

      timeout = setTimeout(() => resolve(func(...args)), waitFor)
    })
}
